<div class="custella-setup-body-not">
  <p-tabView
    class="tabs-low-user"
    #tabView
    (onChange)="handleChange($event, tabView)"
    [(activeIndex)]="activeIndexAccess"
    id="tabView"
    *ngIf="params?.id">

    <!-- Details -->
    <p-tabPanel [header]="loadTabs[0].headerName">
      <app-user-details-v2
        *ngIf="loadTabs[0].highlight"
        (viewShiftsClicked)="goToShiftsTab()"></app-user-details-v2>
    </p-tabPanel>

    <!-- List View -->
    <p-tabPanel [header]="loadTabs[1].headerName" *ngIf="!hideListView">
      <app-user-list-view
        *ngIf="params?.id && profileData && loadTabs[1].highlight"
        [profile]="profileData"
        [profileId]="params.id"
        class="custella-setup-body"></app-user-list-view>
    </p-tabPanel>

    <!-- Notifications -->
    <p-tabPanel [header]="loadTabs[2].headerName" *ngIf="params?.id == auth.getUserId() || isAdmin">
      <app-user-notification
        *ngIf="params?.id && profileData && loadTabs[2].highlight"
        [profile]="profileData"
        [profileId]="params.id"
        class="custella-setup-body-not"></app-user-notification>
    </p-tabPanel>

    <!-- AI -->
    <p-tabPanel
      [header]="loadTabs[3].headerName"
      *ngIf="(params?.id == auth.getUserId() || isAdmin) && addonFeature?.addonAI == 'AI'">
      <app-ai-enable
        *ngIf="loadTabs[3].highlight && params?.id && profileData"
        [profile]="profile"
        [comingFrom]="'User'"
        class="custella-setup-body"></app-ai-enable>
    </p-tabPanel>

    <!-- Shifts -->
    <p-tabPanel [header]="loadTabs[4].headerName" *ngIf="displayNewJO2 && displayNewWORKFLOW2">
      <app-user-shifts
        *ngIf="params?.id && loadTabs[4].highlight"
        [profile]="profile"
        [profileId]="params.id"
        [userId]="params.id"
       ></app-user-shifts>
    </p-tabPanel>

  </p-tabView>
</div>
